// src/utils/indicators.js
export function computeRSI(closes, period = 14) {
  const out = new Array(closes.length).fill(null);
  if (!closes || closes.length < period + 1) return out;

  const gains = [], losses = [];
  for (let i = 1; i < closes.length; i++) {
    const d = closes[i] - closes[i - 1];
    gains.push(Math.max(d, 0));
    losses.push(Math.max(-d, 0));
  }

  let avgGain = 0, avgLoss = 0;
  for (let i = 0; i < period; i++) {
    avgGain += gains[i];
    avgLoss += losses[i];
  }
  avgGain /= period; avgLoss /= period;

  const firstIdx = period;
  let rs = avgLoss === 0 ? Infinity : avgGain / avgLoss;
  out[firstIdx] = 100 - 100 / (1 + rs);

  for (let i = firstIdx + 1; i < closes.length; i++) {
    const g = gains[i - 1];
    const l = losses[i - 1];
    avgGain = (avgGain * (period - 1) + g) / period;
    avgLoss = (avgLoss * (period - 1) + l) / period;
    rs = avgLoss === 0 ? Infinity : avgGain / avgLoss;
    out[i] = 100 - 100 / (1 + rs);
  }
  return out;
}